import { applicationInsights } from '../../ApplicationInsights';

export const logApplicationInsightsTrace = (message: string) => {
    applicationInsights.appInsights.trackTrace({ message });
};

export const logApplicationInsightsError = (error: Error) => {
    applicationInsights.appInsights.trackException({ exception: error });
};
